// import HeroBackground from "./components/HeroBackground"
import './styles/hero_section.css'
import logo from './static/brand-logo.png'
import CallToAction from "./components/CallToAction"
function HeroSection() {
    return (
        <div className="hero-section">
            {/* <HeroBackground /> */}
            <div className="top-section">
                <a href="/"><img className="brand-logo" src={logo} alt="logo" /></a>
                <h1>HEQA: Trasforma la tua passione in
                    <span className='golden'> successo</span>, la tua voce in
                    <span className='golden'> emozione</span>, il tuo talento in
                    <span className='golden'> guadagno</span>!
                </h1>

            </div>
            <CallToAction />
        </div>
    )
}

export default HeroSection